module.exports = __webpack_public_path__ + "ICONInstagram.svg?6a416225b95507da6ebfcb4f00633b29";


//////////////////
// WEBPACK FOOTER
// ./static/ICONInstagram.svg
// module id = 312
// module chunks = 0